import React from "react"

import {Button, Grid, Typography} from "@mui/material"

import {t, Trans} from "@lingui/macro"
import { UseFormReturn } from "react-hook-form"
import * as Yup from "yup"

import {
	mdiPencilOutline,
} from "@mdi/js"
import Icon from "@mdi/react"

import {
	MatesTextField,
	withUseFormHook,
} from "@sinossi/mates-react-library"

import { theme } from "index"
import {Profile, UpdateAssetRequest, UpdateProfileDetails} from "../../models";

const SidebarProfileInfoFormSchema = Yup.object().shape({
	firstName: Yup.string().required('Il campo è obbligatorio'),
	lastName: Yup.string().required('Il campo è obbligatorio'),
	address: Yup.string().required('Il campo è obbligatorio'),
	city: Yup.string().required('Il campo è obbligatorio'),
	phone: Yup.string().required('Il campo è obbligatorio'),
	vatCode: Yup.string().required('Il campo è obbligatorio'),
	province: Yup.string().required('Il campo è obbligatorio'),
	postalCode: Yup.string().required('Il campo è obbligatorio'),
	country: Yup.string().required('Il campo è obbligatorio'),
});

interface SidebarProfileInfoFormProps extends UseFormReturn
{
	profileDetails: Profile
	submit: (request: UpdateProfileDetails) => void
}
interface SidebarProfileInfoFormState
{
	isFormLoaded: boolean,
}
class SidebarProfileInfoForm extends React.Component<SidebarProfileInfoFormProps, SidebarProfileInfoFormState>
{
	private palette = theme.palette

	constructor(props: any) {
		super(props);

		this.state = {
			isFormLoaded: false,
		};
	}

	componentDidMount()
	{
		this.setState(
			() => ({isFormLoaded: true}),
			this.setFormValues
		)
	}

	private setFormValues = () : void => {
		if(this.props.profileDetails.accountDetails.firstName) {
			this.props.setValue("firstName", this.props.profileDetails.accountDetails.firstName)
		}
		if (this.props.profileDetails.accountDetails.lastName){
			this.props.setValue("lastName", this.props.profileDetails.accountDetails.lastName)
		}
		if(this.props.profileDetails.accountDetails.address) {
			this.props.setValue("address", this.props.profileDetails.accountDetails.address)
		}
		if(this.props.profileDetails.accountDetails.city ) {
			this.props.setValue("city", this.props.profileDetails.accountDetails.city)
		}
		if(this.props.profileDetails.accountDetails.province ) {
			this.props.setValue("province", this.props.profileDetails.accountDetails.province)
		}
		if(this.props.profileDetails.accountDetails.postalCode ) {
			this.props.setValue("postalCode", this.props.profileDetails.accountDetails.postalCode)
		}
		if(this.props.profileDetails.accountDetails.country ) {
			this.props.setValue("country", this.props.profileDetails.accountDetails.country)
		}
		if(this.props.profileDetails.accountDetails.phone) {
			this.props.setValue("phone", this.props.profileDetails.accountDetails.phone)
		}
		if(this.props.profileDetails.accountDetails.vatCode) {
			this.props.setValue("vatCode", this.props.profileDetails.accountDetails.vatCode)
		}
	}

	private submitForm = (values: any) : void => {

		let request: UpdateProfileDetails = {
			username: this.props.profileDetails.username,
			accountType: this.props.profileDetails.accountType,
			firstName: this.props.getValues("firstName"),
			lastName: this.props.getValues("lastName"),
			address: this.props.getValues("address"),
			city: this.props.getValues("city"),
			province: this.props.getValues("province"),
			postalCode: this.props.getValues("postalCode"),
			country: this.props.getValues("country"),
			phone: this.props.getValues("phone"),
			vatCode: this.props.getValues("vatCode"),
			fiscalCode: this.props.profileDetails.accountDetails.fiscalCode
		}

		this.props.submit(request)
	}


	render()
	{
		return (
			<form onSubmit={this.props.handleSubmit(this.submitForm)}>
				<Grid container columnSpacing={2} rowSpacing={3} pt={2}>
					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-name",
								message: "Nome",
							})}
							name="firstName"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>
					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-lastName",
								message: "Cognome",
							})}
							name="lastName"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>
					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-address",
								message: "Indirizzo",
							})}
							name="address"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>
					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-city",
								message: "Città",
							})}
							name="city"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>

					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-postalCode",
								message: "CAP",
							})}
							name="postalCode"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>

					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-province",
								message: "Provincia",
							})}
							name="province"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>

					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-country",
								message: "Stato",
							})}
							name="country"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>

					<Grid item xs={12}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-phone",
								message: "Telefono",
							})}
							name="phone"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>

					<Grid item xs={12} sx={{mb: 3}}>
						<MatesTextField
							variant={"standard"}
							label={t({
								id: "spif-vat-code",
								message: "Partita IVA",
							})}
							name="vatCode"
							control={this.props.control}
							trigger={this.props.trigger}
							formState={this.props.formState}
							endAdornment={<Icon path={mdiPencilOutline} size={1} color={this.palette.secondary.main} />}
						/>
					</Grid>
				</Grid>
				<Grid container item xs={12} justifyContent={"center"} alignItems={"center"} paddingTop={"30px"} >
					<Button
						variant="contained"
						type="submit"
						disableElevation
						sx={{
							textTransform: 'none',
							backgroundColor: 'secondary.main',
							color: 'white',
							paddingX: 5,
						}}
					>
						<Typography>
							<Trans id="submit-button">
								Salva
							</Trans>
						</Typography>
					</Button>
				</Grid>
			</form>
		)
	}

}

export default withUseFormHook<{}>(SidebarProfileInfoForm, SidebarProfileInfoFormSchema, {});
